import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { ProcessTypeEnum } from 'src/app/shared/interfaces/process.interface';
import { SelectNumberComponent } from 'src/app/shared/modals/select-number/select-number.component';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { Version } from '../../_interfaces/version.interface';
import { ConfigureThreesixtyLimitComponent } from 'src/app/shared/modals/configure-threesixty-limit/configure-threesixty-limit.component';

@Component({
  selector: 'app-processes-flags',
  templateUrl: './processes-flags.component.html',
  styleUrls: ['./processes-flags.component.scss'],
})
export class ProcessesFlagsComponent extends BaseClass implements OnInit {

  @Input() version: Version = null;
  @Input() processType: ProcessTypeEnum;
  @Input() userAttributesOnProcessAllowedFlag: boolean = false;

  public showSkipTwoPlusTwoCoachingEvaluation: boolean;
  public disableRelationColumn: boolean;
  public userAttributesOnProcessAllowed: boolean;
  public skipThreeSixtySelection: boolean;
  public showThreeSixtyEvaluationLimit: boolean;

  private readonly _numberManualReopeningOptions = [6, 12, 24];

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _modalController: ModalController,
    private _loadingController: LoadingController,
    private _configService: ConfigService
  ) {
    super(_toastController, _translationService);
    this.disableRelationColumn = this._configService.settings.features.disableRelationColumn;
    this.showSkipTwoPlusTwoCoachingEvaluation = this._configService.settings.features.showSkipTwoPlusTwoCoachingEvaluation;
    this.userAttributesOnProcessAllowed = this._configService.settings.features.userAttributesOnProcessAllowed;
    this.skipThreeSixtySelection = this._configService.settings.features.skipThreeSixtySelection;
    this.showThreeSixtyEvaluationLimit = this._configService.settings.features.showThreeSixtyEvaluationLimit;
  }

  ngOnInit() { }


  public async toggleManualReopening($event: CustomEvent) {
    if ($event.detail.checked && this.version && this.version.manualReopeningTime === null) {
      await this._openManualReopeningModal();
    } else {
      this.version.manualReopeningTime = null;
    }
  }

  public onChangeThreeSixtyEvaluationLimit(limitIsEnabled: boolean) {
    if (limitIsEnabled) {
      this._configureThreesixtyLimitModal();
    } else {
      this.version.threeSixtyEvaluationLimit = null;
      this.version.threeSixtyEvaluationTimespanInHours = null;
    }
  }

  public openThreesixtyLimitModal() {
    this._configureThreesixtyLimitModal();
  }

  private async _configureThreesixtyLimitModal() {
    const modal = await this._modalController.create({
      component: ConfigureThreesixtyLimitComponent,
      cssClass: "select-number",
      componentProps: {
        version: this.version,
      },
    });
    await modal.present();

    await modal.onDidDismiss().then((dismissEvent) => {
      if (dismissEvent.data) this.version = dismissEvent.data as Version;
    });
  }

  private async _openManualReopeningModal() {
    const modal = await this._modalController.create({
      component: SelectNumberComponent,
      cssClass: "select-number",
      componentProps: {
        title: "manageVersion.hoursDelayedForFreeEvaluation",
        options: this._numberManualReopeningOptions,
        selectedNumber: this.version.manualReopeningTime,
      },
    });
    await modal.present();

    await modal.onDidDismiss().then((dismissEvent) => {
      if (dismissEvent.data) this.version.manualReopeningTime = dismissEvent.data;
    });
  }
  public async editManualReopening() {
    if (this.version && this.version.manualReopeningTime !== null && this.version.manualReopeningTime !== undefined) await this._openManualReopeningModal();
  }

}
